import { useEffect } from "react";
import PropTypes from "prop-types";
import upvoty from "./upvoty";
import "./upvoty.scss";

function UpvotyWidget({ ssoToken = null }) {
  const { REACT_APP_UPVOTY_BOARD_HASH: boardHash, REACT_APP_UPVOTY_BASE_URL: baseUrl } = import.meta.env;

  useEffect(() => {
    upvoty.init("render", { boardHash, ssoToken, baseUrl });
    return () => {
      upvoty.destroy();
    };
  }, []);
  return <div data-upvoty />;
}

UpvotyWidget.propTypes = {
  ssoToken: PropTypes.string.isRequired,
};

export default UpvotyWidget;
